import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/search';

const namespace = 'LITIGATION';

export const FETCH_SEARCH_CONFIG_START = `${namespace}/FETCH_SEARCH_CONFIG_START`;
export const FETCH_SEARCH_CONFIG_SUCCESS = `${namespace}/FETCH_SEARCH_CONFIG_SUCCESS`;
export const FETCH_SEARCH_CONFIG_ERROR = `${namespace}/FETCH_SEARCH_CONFIG_ERROR`;

export const FETCH_SEARCH_CODES_START = `${namespace}/FETCH_SEARCH_CODES_START`;
export const FETCH_SEARCH_CODES_SUCCESS = `${namespace}/FETCH_SEARCH_CODES_SUCCESS`;
export const FETCH_SEARCH_CODES_ERROR = `${namespace}/FETCH_SEARCH_CODES_ERROR`;

export const FETCH_SEARCH_RESULTS_CONFIG_START = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_START`;
export const FETCH_SEARCH_RESULTS_CONFIG_SUCCESS = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_SUCCESS`;
export const FETCH_SEARCH_RESULTS_CONFIG_ERROR = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_ERROR`;

export const SEARCH_START = `${namespace}/SEARCH_START`;
export const SEARCH_SUCCESS = `${namespace}/SEARCH_SUCCESS`;
export const SEARCH_ERROR = `${namespace}/SEARCH_ERROR`;

export const SEARCH_STANDALONE_START = `${namespace}/SEARCH_STANDALONE_START`;
export const SEARCH_STANDALONE_SUCCESS = `${namespace}/SEARCH_STANDALONE_SUCCESS`;
export const SEARCH_STANDALONE_ERROR = `${namespace}/SEARCH_STANDALONE_ERROR`;

export const FETCH_CODEFILE_CASE_STATUS_START = `${namespace}/FETCH_CODEFILE_CASE_STATUS_START`;
export const FETCH_CODEFILE_CASE_STATUS_SUCCESS = `${namespace}/FETCH_CODEFILE_CASE_STATUS_SUCCESS`;
export const FETCH_CODEFILE_CASE_STATUS_ERROR = `${namespace}/FETCH_CODEFILE_CASE_STATUS_ERROR`;

export const FETCH_CODEFILE_JURY_TYPE_START = `${namespace}/FETCH_CODEFILE_JURY_TYPE_START`;
export const FETCH_CODEFILE_JURY_TYPE_SUCCESS = `${namespace}/FETCH_CODEFILE_JURY_TYPE_SUCCESS`;
export const FETCH_CODEFILE_JURY_TYPE_ERROR = `${namespace}/FETCH_CODEFILE_JURY_TYPE_ERROR`;

export const FETCH_CODEFILE_TRIAL_TYPE_START = `${namespace}/FETCH_CODEFILE_TRIAL_TYPE_START`;
export const FETCH_CODEFILE_TRIAL_TYPE_SUCCESS = `${namespace}/FETCH_CODEFILE_TRIAL_TYPE_SUCCESS`;
export const FETCH_CODEFILE_TRIAL_TYPE_ERROR = `${namespace}/FETCH_CODEFILE_TRIAL_TYPE_ERROR`;

export const FETCH_CODEFILE_APPRAISER_TYPE_START = `${namespace}/FETCH_CODEFILE_APPRAISER_TYPE_START`;
export const FETCH_CODEFILE_APPRAISER_TYPE_SUCCESS = `${namespace}/FETCH_CODEFILE_APPRAISER_TYPE_SUCCESS`;
export const FETCH_CODEFILE_APPRAISER_TYPE_ERROR = `${namespace}/FETCH_CODEFILE_APPRAISER_TYPE_ERROR`;

export const FETCH_CODEFILE_DISCOVERY_STATUS_START = `${namespace}/FETCH_CODEFILE_DISCOVERY_STATUS_START`;
export const FETCH_CODEFILE_DISCOVERY_STATUS_SUCCESS = `${namespace}/FETCH_CODEFILE_DISCOVERY_STATUS_SUCCESS`;
export const FETCH_CODEFILE_DISCOVERY_STATUS_ERROR = `${namespace}/FETCH_CODEFILE_DISCOVERY_STATUS_ERROR`;

export const FETCH_CODEFILE_OFFER_STATUS_START = `${namespace}/FETCH_CODEFILE_OFFER_STATUS_START`;
export const FETCH_CODEFILE_OFFER_STATUS_SUCCESS = `${namespace}/FETCH_CODEFILE_OFFER_STATUS_SUCCESS`;
export const FETCH_CODEFILE_OFFER_STATUS_ERROR = `${namespace}/FETCH_CODEFILE_OFFER_STATUS_ERROR`;

export const FETCH_CODEFILE_MOTION_STATUS_START = `${namespace}/FETCH_CODEFILE_MOTION_STATUS_START`;
export const FETCH_CODEFILE_MOTION_STATUS_SUCCESS = `${namespace}/FETCH_CODEFILE_MOTION_STATUS_SUCCESS`;
export const FETCH_CODEFILE_MOTION_STATUS_ERROR = `${namespace}/FETCH_CODEFILE_MOTION_STATUS_ERROR`;

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;
export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;
export const CHANGE_SORT_MODEL = `${namespace}/CHANGE_SORT_MODEL`;
export const CHANGE_FILTER_MODEL = `${namespace}/CHANGE_FILTER_MODEL`;

export const FETCH_CASES_UPDATE_CONFIG_START = `${namespace}/FETCH_CASES_UPDATE_CONFIG_START`;
export const FETCH_CASES_UPDATE_CONFIG_SUCCESS = `${namespace}/FETCH_CASES_UPDATE_CONFIG_SUCCESS`;
export const FETCH_CASES_UPDATE_CONFIG_ERROR = `${namespace}/FETCH_CASES_UPDATE_CONFIG_ERROR`;

export const fetchCasesUpdateConfig = makeApiActionCreatorV3(
  api.fetchCasesUpdateConfig,
  FETCH_CASES_UPDATE_CONFIG_START,
  FETCH_CASES_UPDATE_CONFIG_SUCCESS,
  FETCH_CASES_UPDATE_CONFIG_ERROR,
);

export const fetchSearchConfig = makeApiActionCreatorV3(
  api.fetchSearchConfig,
  FETCH_SEARCH_CONFIG_START,
  FETCH_SEARCH_CONFIG_SUCCESS,
  FETCH_SEARCH_CONFIG_ERROR,
);

export const fetchSearchCodes = makeApiActionCreatorV3(
  api.fetchSearchCodes,
  FETCH_SEARCH_CODES_START,
  FETCH_SEARCH_CODES_SUCCESS,
  FETCH_SEARCH_CODES_ERROR,
);

export const fetchSearchResultsConfig = makeApiActionCreatorV3(
  api.fetchSearchResultsConfig,
  FETCH_SEARCH_RESULTS_CONFIG_START,
  FETCH_SEARCH_RESULTS_CONFIG_SUCCESS,
  FETCH_SEARCH_RESULTS_CONFIG_ERROR,
);

export const search = makeApiActionCreatorV3(
  api.search,
  SEARCH_START,
  SEARCH_SUCCESS,
  SEARCH_ERROR,
);

export const searchStandalone = makeApiActionCreatorV3(
  api.searchStandalone,
  SEARCH_STANDALONE_START,
  SEARCH_STANDALONE_SUCCESS,
  SEARCH_STANDALONE_ERROR,
);

export const fetchCodefileCaseStatus = makeApiActionCreatorV3(
  api.fetchCodefileCaseStatus,
  FETCH_CODEFILE_CASE_STATUS_START,
  FETCH_CODEFILE_CASE_STATUS_SUCCESS,
  FETCH_CODEFILE_CASE_STATUS_ERROR,
);

export const fetchCodefileJuryType = makeApiActionCreatorV3(
  api.fetchCodefileJuryType,
  FETCH_CODEFILE_JURY_TYPE_START,
  FETCH_CODEFILE_JURY_TYPE_SUCCESS,
  FETCH_CODEFILE_JURY_TYPE_ERROR,
);

export const fetchCodefileTrialType = makeApiActionCreatorV3(
  api.fetchCodefileTrialType,
  FETCH_CODEFILE_TRIAL_TYPE_START,
  FETCH_CODEFILE_TRIAL_TYPE_SUCCESS,
  FETCH_CODEFILE_TRIAL_TYPE_ERROR,
);

export const fetchCodefileAppraiserType = makeApiActionCreatorV3(
  api.fetchCodefileAppraiserType,
  FETCH_CODEFILE_APPRAISER_TYPE_START,
  FETCH_CODEFILE_APPRAISER_TYPE_SUCCESS,
  FETCH_CODEFILE_APPRAISER_TYPE_ERROR,
);

export const fetchCodefileDiscoveryStatus = makeApiActionCreatorV3(
  api.fetchCodefileDiscoveryStatus,
  FETCH_CODEFILE_DISCOVERY_STATUS_START,
  FETCH_CODEFILE_DISCOVERY_STATUS_SUCCESS,
  FETCH_CODEFILE_DISCOVERY_STATUS_ERROR,
);

export const fetchCodefileMotionStatus = makeApiActionCreatorV3(
  api.fetchCodefileMotionStatus,
  FETCH_CODEFILE_MOTION_STATUS_START,
  FETCH_CODEFILE_MOTION_STATUS_SUCCESS,
  FETCH_CODEFILE_MOTION_STATUS_ERROR,
);

export const fetchCodefileOfferStatus = makeApiActionCreatorV3(
  api.fetchCodefileOfferStatus,
  FETCH_CODEFILE_OFFER_STATUS_START,
  FETCH_CODEFILE_OFFER_STATUS_SUCCESS,
  FETCH_CODEFILE_OFFER_STATUS_ERROR,
);

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const changeSortModel = model => ({
  type: CHANGE_SORT_MODEL,
  payload: model,
});

export const changeFilterModel = model => ({
  type: CHANGE_FILTER_MODEL,
  payload: model,
});
